<template>
  <el-dialog
    :visible="visible"
    :custom-class="classModal"
    append-to-body
    :title="title"
    @close="$emit('update:visible', false)"
  >
    <template v-if="isSuccessfulTest">
      <p class="test-modal__message">
        Вы успешно завершили пробный урок. Для получения доступа ко всему курсу, необходимо подать
        заявку.
      </p>
      <el-button type="success" class="test-modal__button" @click="redirectToRegister"
        >Подать заявку</el-button
      >
    </template>
    <template v-else>
      <iframe
        src="https://lms.citronium.com/sites/default/files/opigno_tincan_extracted/_____________1_5/res/index.html"
        frameborder="0"
      />
      <div class="test-modal__footer">
        <el-button type="success" size="small" @click="submit">Готово</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'ModalTest',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    isSuccessfulTest: false
  }),

  computed: {
    title() {
      return this.isSuccessfulTest ? 'Поздравляем!' : ''
    },

    classModal() {
      return this.isSuccessfulTest ? 'test-modal test-modal--success' : 'test-modal'
    }
  },

  methods: {
    submit() {
      this.isSuccessfulTest = true
    },

    redirectToRegister() {
      this.$router.push({
        name: 'register-step-one'
      })
    }
  }
}
</script>

<style lang="scss">
.test-modal {
  &:not(&--success) {
    width: 1300px !important;
  }

  &--success {
    width: 480px;
  }

  &__message {
    font-weight: normal;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: $deepdark;
    margin-bottom: 48px;
    letter-spacing: 0.35px;

    @include sm-and-down {
      font-size: 19px;
      line-height: 23px;
      margin-bottom: 32px;
    }
  }

  &__button {
    font-size: 18px;
    display: block;
    margin: 0 auto;

    @include sm-and-down {
      width: 100%;
    }
  }

  .el-dialog {
    &__title {
      text-transform: uppercase;
    }

    &__header {
      padding: 24px 18px 48px;

      @include sm-and-down {
        padding: 24px 18px 32px;
      }
    }

    &__body {
      padding: 0 18px 32px;

      @include md-and-down {
        padding: 0 16px 16px;
      }
    }
  }

  @include lg-and-down {
    width: 100% !important;
  }

  iframe {
    width: 100%;
    height: 650px;

    @include sm-and-down {
      height: 300px;
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }

  .el-dialog__header {
    padding: 28px;
  }
}
</style>
